import { render, staticRenderFns } from "./add-form.vue?vue&type=template&id=55c0ca91&scoped=true&"
import script from "./add-form.vue?vue&type=script&lang=js&"
export * from "./add-form.vue?vue&type=script&lang=js&"
import style0 from "./add-form.vue?vue&type=style&index=0&id=55c0ca91&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c0ca91",
  null
  
)

export default component.exports